import { and, isNumberControl, JsonFormsRendererRegistryEntry, rankWith, optionIs } from '@jsonforms/core';
import controlRenderer from './NumberControlRenderer.vue';

export const entry: JsonFormsRendererRegistryEntry = {
  renderer: controlRenderer,
  tester: rankWith(10, and(isNumberControl, optionIs('version', 'v2'))),
};
